module.exports = __webpack_public_path__ + "assets/img/rating_star_starred.svg";